import { render, staticRenderFns } from "./BackgroundGradient.vue?vue&type=template&id=6b87cacb&scoped=true&"
import script from "./BackgroundGradient.vue?vue&type=script&lang=js&"
export * from "./BackgroundGradient.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundGradient.vue?vue&type=style&index=0&id=6b87cacb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87cacb",
  null
  
)

export default component.exports